import { Routes } from '@angular/router';
import {
  isAdminGuard,
  isAuthenticatedGuard,
  LicensesComponent,
  P404Component,
  P500Component,
  ProfileComponent,
  ProfileSessionComponent,
  WaitingListComponent,
} from '@nimmsta/ng-commons-lib';
import {
  AdminUserOverviewComponent,
  ConfigurationListComponent,
  OrganizationsComponent,
  OrganizationDetailsComponent,
} from '@nimmsta/ng-b2b-lib';
import { EmptyDashboardComponent } from './components/empty-dashboard.component';
import { LayoutComponent } from './layout/layout.component';

export const routes: Routes = [
  {
    path: '500',
    component: P500Component,
  },
  {
    path: 'waiting-list',
    component: WaitingListComponent,
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [isAuthenticatedGuard, isAdminGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard',
      },
      {
        path: 'dashboard',
        pathMatch: 'full',
        component: EmptyDashboardComponent,
      },
      {
        path: 'profile',
        component: ProfileComponent,
      },
      {
        path: 'profile/sessions',
        component: ProfileSessionComponent,
      },
      {
        path: 'devices',
        loadChildren: () =>
          import('./pages/devices/device.routes').then((m) => m.routes),
      },
      {
        path: 'reports',
        loadChildren: () =>
          import('./pages/reports/reports.routes').then((m) => m.routes),
      },
      {
        path: 'batch-items',
        loadComponent: () =>
          import('./pages/batch-items/batch-items.component').then(
            (m) => m.BatchItemsComponent,
          ),
      },
      {
        path: 'contents',
        loadChildren: () =>
          import('./pages/content/content.routes').then((m) => m.routes),
      },
      {
        path: 'configurations',
        component: ConfigurationListComponent,
      },
      {
        path: 'organizations',
        component: OrganizationsComponent,
      },
      {
        path: 'organizations/:id',
        component: OrganizationDetailsComponent,
      },
      {
        path: 'users',
        component: AdminUserOverviewComponent,
      },
      {
        path: 'access-requests',
        loadComponent: () =>
          import('./pages/access-request/access-request.component').then(
            (m) => m.AccessRequestComponent,
          ),
      },
      {
        path: 'licenses',
        component: LicensesComponent,
      },
    ],
  },
  {
    path: '**',
    component: P404Component,
  },
];
